export const HOTKEYS = ['u', 'l', 'c', 'i', 'a'];
